'use strict';
const cognitoMindMupProfile = require('./cognito-mindmup-profile'),
	getAccountTypeInfo = require('@mindmup/mindmup-common/src/get-account-type-info'),
	PROVIDER_NAME = 'cognito';
	// SESSION_POKE_INTERVAL = 20 * 60 * 1000;
module.exports = function CognitoAuthenticator(cognitoApi, authenticationModel) {
	if (!cognitoApi || !authenticationModel) {
		throw new Error('invalid-args');
	}

	const self = this,
		onAuthenticatedProfile = (profile) => {
			if (profile) {
				authenticationModel.authenticatedProfile(() => cognitoMindMupProfile(cognitoApi, PROVIDER_NAME, true));
			}
			return profile;
		},
		onAuthenticationFailed = (reason) => {
			authenticationModel.authenticationFailed();
			throw reason;
		};

	self.providerName = function () {
		return PROVIDER_NAME;
	};
	self.getProfile = function () {
		return cognitoMindMupProfile(cognitoApi, PROVIDER_NAME);
	};
	self.backgroundAuthenticate = function () {
		authenticationModel.authenticationStarted();
		return cognitoMindMupProfile(cognitoApi, PROVIDER_NAME)
		.then(onAuthenticatedProfile)
		.catch(onAuthenticationFailed);
	};

	self.authenticate = function (username, password) {
		return cognitoApi.signIn(username, password)
		.then(() => cognitoMindMupProfile(cognitoApi, PROVIDER_NAME))
		.then(onAuthenticatedProfile)
		.catch(onAuthenticationFailed);
	};

	authenticationModel.addEventListener('not-authenticated', function (reason) {
		if (reason === 'signed-out') {
			cognitoApi.signOut();
		}
	});

	authenticationModel.addEventListener('authenticatedProfile', function (profile) {
		if (profile && profile.provider !== PROVIDER_NAME) {
			cognitoApi.signOut();
			if (profile.license && profile.license.accountType) {
				const accountTypeInfo = getAccountTypeInfo(profile.license.accountType);
				if (accountTypeInfo.cognitoAuthenticated) {
					cognitoApi.signInWithLicense(profile.license)
					.then(() => cognitoMindMupProfile(cognitoApi, PROVIDER_NAME))
					.then(onAuthenticatedProfile)
					.catch(onAuthenticationFailed);
				}
			}
		}
	});

	authenticationModel.addEventListener('signoutOthersRequired', (profile) => {
		if (profile && profile.provider === PROVIDER_NAME) {
			cognitoApi.globalSignOut()
			.then(() => cognitoApi.signInWithLicense(profile.license));
		}
	});
};

